module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("The Bear's Cage Unlocked")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#acknowledgement"
    }
  }, [_vm._v("Acknowledgement")])]), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#morning"
    }
  }, [_vm._v("1. Morning")])]), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#nessa"
    }
  }, [_vm._v("2. Nessa")])]), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#the-unforeseen"
    }
  }, [_vm._v("3. The Unforeseen")])]), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch008#the-intelligence-man"
    }
  }, [_vm._v("4. The Intelligence Man")])]), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch009#the-parting-of-the-ways"
    }
  }, [_vm._v("5. The Parting of the Ways")])]), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#first-contact",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. First Contact")])]), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#the-way-of-it",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. The Way of It")])]), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#the-ministers",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. The Ministers")])]), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#homecoming",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. Homecoming")])]), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#a-private-conversation",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. A Private Conversation")])]), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#the-mission",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. The Mission")])]), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#recovery",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. Recovery")])]), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#home-run",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. Home Run")])]), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#a-meeting",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. A Meeting")])]), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#hiring-fair",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. Hiring Fair")])]), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#holding-pattern",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16. Holding Pattern")])]), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#stocktake",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17. Stocktake")])]), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#filip",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18. Filip")])]), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#casting-the-accounts",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19. Casting the Accounts")])]), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#the-ashes-of-the-day",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20. The Ashes of the Day")])]), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#still-waters",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21. Still Waters")])]), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch026#the-big-smoke",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22. The Big Smoke")])]), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch027#plans",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23. Plans")])]), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch028#supply-chain",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24. Supply Chain")])]), _c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch029#review-stand",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25. Review Stand")])]), _c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch030#made-in-heaven",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26. Made in Heaven")])]), _c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch031#through-a-glass-darkly",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27. Through a Glass Darkly")])]), _c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch032#consequences",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28. Consequences")])]), _c('li', {
    attrs: {
      "id": "toc-li-33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch033#trading-with-the-enemy",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29. Trading with the Enemy")])]), _c('li', {
    attrs: {
      "id": "toc-li-34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch034#state-of-readiness",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30. State of Readiness")])]), _c('li', {
    attrs: {
      "id": "toc-li-35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch035#night-crossing",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31. Night Crossing")])]), _c('li', {
    attrs: {
      "id": "toc-li-36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch036#breakthrough",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32. Breakthrough")])]), _c('li', {
    attrs: {
      "id": "toc-li-37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch037#a-walk-in-the-park",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33. A Walk in the Park")])]), _c('li', {
    attrs: {
      "id": "toc-li-38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch038#the-heath",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34. The Heath")])]), _c('li', {
    attrs: {
      "id": "toc-li-39"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch039#creatures-of-the-night",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35. Creatures of the Night")])]), _c('li', {
    attrs: {
      "id": "toc-li-40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch040#game-changer",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36. Game Changer")])]), _c('li', {
    attrs: {
      "id": "toc-li-41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch041#plainsong",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37. Plainsong")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0